// test1134
(1134 && 0);
